import React from "react";
import styled from "styled-components";

const ContentContainer = styled.div`
  padding: 2rem;
  background-color: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  min-height: 80vh;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 1rem;
`;

const Info = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.9rem;
  color: #7f8c8d;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
  align-items: center;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
`;

const Label = styled.span`
  font-weight: bold;
  color: #34495e;
  margin-right: 0.3rem;
`;

const Content = styled.div`
  font-size: 1rem;
  color: #4f4f4f;
  line-height: 1.8;
  margin-bottom: 2rem;
`;

const BackButton = styled.button`
  padding: 0.4rem 1rem;
  background-color: #bdc3c7;
  color: white;
  font-size: 0.9rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: auto;

  &:hover {
    background-color: #d46618;
  }
`;

const LinkButton = styled.a`
  padding: 0.4rem 1rem;
  background-color: #bdc3c7;
  color: white;
  font-size: 0.9rem;
  text-decoration: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 1rem;

  &:hover {
    background-color: #2980b9;
  }
`;

const IframeContainer = styled.div`
  margin-top: 2rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100vh;
  border: none;
`;

const RegulationContent = ({ regulation }) => {
  return (
    <ContentContainer>
      <Title>{regulation.title}</Title>
      <Info>
        <InfoItem>
          <Label>카테고리:</Label> {regulation.category}
        </InfoItem>
        <InfoItem>
          <Label>지역:</Label> {regulation.region}
        </InfoItem>
        <InfoItem>
          <Label>시작일:</Label> {regulation.startDate}
        </InfoItem>
        <InfoItem>
          <Label>종료일:</Label> {regulation.endDate}
        </InfoItem>
        <InfoItem>
          <Label>상태:</Label> {regulation.status}
        </InfoItem>
        <LinkButton
          href={regulation.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          원본 보러가기
        </LinkButton>
        <BackButton onClick={() => window.history.back()}>목록</BackButton>
      </Info>
      <Content>{regulation.description}</Content>
      <IframeContainer>
        <StyledIframe
          src={regulation.url}
          title="Regulation Details"
        ></StyledIframe>
      </IframeContainer>
    </ContentContainer>
  );
};

export default RegulationContent;
